<template>
  <div class="top-view">
    <HeroSection />
    <FeaturesSection />
    <PriceSection />
    <EquipmentSection />
    <FlowSection />
    <GallerySection />
    <FAQSection />
    <GoogleMap />
    <CTASection />
  </div>
</template>

<script>
import HeroSection from '@/components/sections/HeroSection.vue';
import FeaturesSection from '@/components/sections/FeaturesSection.vue';
import PriceSection from '@/components/sections/PriceSection.vue';
import EquipmentSection from '@/components/sections/EquipmentSection.vue';
import FlowSection from '@/components/sections/FlowSection.vue';
import GallerySection from '@/components/sections/GallerySection.vue';
import FAQSection from '@/components/sections/FAQSection.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import CTASection from '@/components/sections/CTASection.vue';

export default {
  name: 'TopView',
  components: {
    HeroSection,
    FeaturesSection,
    PriceSection,
    EquipmentSection,
    FlowSection,
    GallerySection,
    FAQSection,
    GoogleMap,
    CTASection
  },
  beforeCreate() {
    console.log('[TopView] beforeCreate');
  },
  created() {
    console.log('[TopView] created');
  },
  beforeMount() {
    console.log('[TopView] beforeMount');
  },
  mounted() {
    console.log('[TopView] mounted');
    this.$nextTick(() => {
      console.log('[TopView] nextTick - All child components should be rendered');
      const sections = this.$el.querySelectorAll('section');
      console.log('[TopView] Found sections:', sections.length);
    });
  },
  beforeUnmount() {
    console.log('[TopView] beforeUnmount');
  },
  unmounted() {
    console.log('[TopView] unmounted');
  }
}
</script>

<style lang="scss" scoped>
.top-view {
  // スタイルが必要な場合はここに追加
}
</style>
